<template>
  <div 
    :class="{'internalTitleDescriptionImageParallax--contentLeftPosition' : contentLeft}"
    class="internalTitleDescriptionImageParallax">
    <div class="internalTitleDescriptionImageParallax__contents">
      <div 
        v-waypoint="{ active: true, callback: $_onWaypoint, options: intersectionOptions }"
        v-for="(content, index) of contents"
        :key="index"
        class="internalTitleDescriptionImageParallax__contents__element">
        <h4 
          v-if="typeof content.title !== 'undefined'"
          v-html="content.title"/>
        <div 
          v-html="content.description"
          v-if="typeof content.description !== 'undefined'"
          class="internalTitleDescriptionImageParallax__contents__element__description">
        </div>
        <p 
          v-if="typeof content.label !== 'undefined'"
          class="internalTitleDescriptionImageParallax__contents__element__label">
          {{ content.label }}
        </p>
        <div 
          v-if="typeof content.labelContent !== 'undefined'"
          v-html="content.labelContent"
          class="internalTitleDescriptionImageParallax__contents__element__label-content">
        </div>
      </div>
    </div>
    <div 
      v-rellax="{ rellaxSpeed }"
      class="internalTitleDescriptionImageParallax__pictures">
      <picture 
        v-waypoint="{ active: true, callback: $_onWaypoint, options: intersectionOptions }"
        v-for="(image, index) of images"
        :key="index"
        class="internalTitleDescriptionImageParallax__picture">
        <source :srcset="image.landscape" media="(orientation: landscape)">
        <img :src="image.portrait">
      </picture>
    </div>
  </div>
</template>

<script>
import Rellax from 'rellax'
import waypointEffect from '@/mixins/waypointEffect.js'

export default {
  name: 'InternalTitleDescriptionImageParallax',
  mixins: [waypointEffect],
  data: () => ({
    rellaxRef: undefined
  }),
  props: {
    images: {
      type: Array,
      required: false
    },
    contents: {
      type: Array,
      required: false
    },
    contentLeft: {
      type: Boolean,
      default: true
    },
    rellaxSpeed: {
      type: Number,
      default: undefined
    }
  },
  directives: {
    'rellax': {
      inserted (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined'){
          const rellaxRef = new Rellax(el, {
            speed: binding.value.rellaxSpeed,
            center: true,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false,
            percentage: 0.5
          })
          vnode.context.$data.rellax = rellaxRef
        }
      },
      componentUpdated(el, binding, vnode){
        if (typeof binding.value.rellaxSpeed !== 'undefined') {
          if (binding.value.rellaxSpeed !== binding.oldValue.rellaxSpeed){
          vnode.context.$data.rellax.destroy()
          const rellaxRef = new Rellax(el, {
            speed: binding.value.rellaxSpeed,
            center: true,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false,
            percentage: 0.5
          })
          vnode.context.$data.rellax = rellaxRef
          }
          else vnode.context.$data.rellax.refresh()
        }
      },
      unbind (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.destroy()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./internalTitleDescImgParallax.scss";
  @import "./waypoint-effects.scss";
</style>
  